export default __webpack_public_path__ + "static/media/align-justify.4cf4e665.svg";